export const version = "address/5.4.0";
//# sourceMappingURL=_version.js.map